import { ChildrenLoadingContainer } from '../../../styled-components.js'
import { SpinnerGrey } from '../../../../../atoms/icons/special/index.js'
import { iconSizeOptions } from '../../../../../atoms/icons/icons-sizes.js'
import { FormattedMessage } from 'react-intl'

const QuickSelectLoadingItem = () => {
  return (
    <ChildrenLoadingContainer>
      <SpinnerGrey size={iconSizeOptions['ICON-S']} />
      <FormattedMessage id="loading" />
      ...
    </ChildrenLoadingContainer>
  )
}

export default QuickSelectLoadingItem
